/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AppraisalTranslation
 */
export interface AppraisalTranslation {
    /**
     * 
     * @type {string}
     * @memberof AppraisalTranslation
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AppraisalTranslation
     */
    comment?: string;
}

/**
 * Check if a given object implements the AppraisalTranslation interface.
 */
export function instanceOfAppraisalTranslation(value: object): value is AppraisalTranslation {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function AppraisalTranslationFromJSON(json: any): AppraisalTranslation {
    return AppraisalTranslationFromJSONTyped(json, false);
}

export function AppraisalTranslationFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppraisalTranslation {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}

export function AppraisalTranslationToJSON(value?: AppraisalTranslation | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'comment': value['comment'],
    };
}

